import axios from '../../api/axios';

/**
 * Cliente plano (no Redux) para preferencias de tabla por usuario.
 * Cada llamada usa el mismo `axios` que las demas acciones de la app.
 *
 * Se invoca desde `useTablePrefs` para hidratar al montar y para hacer flush
 * debounced cuando el usuario cambia filtros, columnas, etc.
 */

const buildUrl = (userId, tableKey) =>
	`/users/${encodeURIComponent(userId)}/table-prefs/${encodeURIComponent(tableKey)}`;

/**
 * Devuelve `{ prefs, updatedAt, version }` o `null` si no hay registro/error.
 * Nunca lanza para no romper el render: el hook decide degradar a sessionStorage/defaults.
 */
export const fetchTablePref = async (userId, tableKey) => {
	if (!userId || !tableKey) return null;
	try {
		const response = await axios.get(buildUrl(userId, tableKey), {
			withCredentials: true,
		});
		if (response.status !== 200) return null;
		const { prefs, updatedAt, version } = response.data || {};
		if (!prefs) return null;
		return { prefs, updatedAt, version };
	} catch {
		return null;
	}
};

/** Upsert silencioso: devuelve `updatedAt` o `null` si fallo. */
export const saveTablePref = async (userId, tableKey, prefs) => {
	if (!userId || !tableKey) return null;
	try {
		const response = await axios.put(
			buildUrl(userId, tableKey),
			{ prefs },
			{ withCredentials: true },
		);
		if (response.status !== 200) return null;
		return response.data?.updatedAt || null;
	} catch {
		return null;
	}
};

/** Borra el registro remoto (usado por `resetPrefs`). No lanza. */
export const deleteTablePref = async (userId, tableKey) => {
	if (!userId || !tableKey) return false;
	try {
		const response = await axios.delete(buildUrl(userId, tableKey), {
			withCredentials: true,
		});
		return response.status === 200;
	} catch {
		return false;
	}
};
